var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3X3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 53,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 105,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 53,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 105,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 53,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 105,
    width: 45,
    height: 45,
    rx: 10,
    fill: "#A0C4FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3X3);
export default __webpack_public_path__ + "static/media/3x3.e3bd3d9b99fae09533a8350c39ce30ff.svg";
export { ForwardRef as ReactComponent };